import React from 'react';
import { Link } from 'react-router-dom';
import { FaQuestionCircle, FaChevronRight } from 'react-icons/fa';

const HelpOption = ({ isShow, icon, optionTitle, optionCaption, action }) => {
  if (!isShow) return null;

  return (
    <button onClick={action} className="flex justify-between items-center p-3 mb-2 bg-gray-100 rounded-lg w-full hover:bg-gray-200">
      <div className="flex items-center">
        <div className="h-8 w-8 flex justify-center items-center bg-gray-300 rounded-full">
          {icon}
        </div>
        <div className="ml-3 text-left">
          <p className="text-sm font-semibold text-gray-700">{optionTitle}</p>
          {optionCaption && <p className="text-xs text-gray-500">{optionCaption}</p>}
        </div>
      </div>
      <FaChevronRight className="text-gray-500" />
    </button>
  );
};

const InfoHelpOptions = ({
  showDownload,
  actionDownload,
  showFindLostItem,
  actionFindLostItem,
  showIssueWithPayment,
  actionIssueWithPayment,
  showChatWithUs,
  actionChatWithUs,
}) => {
  return (
    <div className="p-4 bg-white rounded-lg shadow-md">
      <h2 className="text-lg font-semibold text-gray-800 mb-3">Get Help</h2>
      <div className="space-y-2">
        <HelpOption isShow={showDownload} icon={<FaQuestionCircle />} optionTitle="Download Invoice" action={actionDownload} />
        <HelpOption isShow={showFindLostItem} icon={<FaQuestionCircle />} optionTitle="Find Lost Item" action={actionFindLostItem} />
        <HelpOption isShow={showIssueWithPayment} icon={<FaQuestionCircle />} optionTitle="Issue with Payment" action={actionIssueWithPayment} />
        <HelpOption isShow={showChatWithUs} icon={<FaQuestionCircle />} optionTitle="Chat with Us" action={actionChatWithUs} />
      </div>
    </div>
  );
};

export default InfoHelpOptions;
